import { FlexibleTranslationKey } from "@shared/i18n/types";
import { useTranslation } from "react-i18next";
import { ActivityType } from "app/_modules/pathways/entities";

export const dynamicTranslations = () => {
  const { t: strictT } = useTranslation();
  const t = strictT as (key: FlexibleTranslationKey, options?: any) => string;
  return { t };
}


export const generateActivityTitleTranslation = (
  activityName: string,
  activityType: string,
  variant: 'title' | 'activity' = 'title'
): string => {
  switch (activityType) {
    case ActivityType.PATHWAY_VITAL_PARAMETER:
      return `vitalParameters.${activityName}.${variant}`;
    case ActivityType.PATHWAY_DRUG:
      return activityName;
    case ActivityType.PATHWAY_QUESTIONNAIRE:
      return activityName;
    case ActivityType.PATHWAY_EXAM:
      return `exams.${activityName}`;
    case ActivityType.PATHWAY_APPOINTMENT:
      return `televisits.${activityName}`;
    default:
      return activityName;
  }
}
